<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="pricing_rules"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class PricingRulerDetail extends Vue {
  data = {}

  get columns() {
    return [
      ...createColumns.call(this),
      {
        prop: 'action',
        label: '操作',
        edit: true,
        delete: {
          handler: this.handleDelete
        }
      }
    ]
  }

  async mounted() {
    this.data = await this.$request.get(`/pricing_rules/${this.$route.params.id}`);
  }

  async handleDelete({ row }) {
    await this.$autoLoading(this.$request.delete(`/pricing_rules/${row.id}`));
    this.$message.success('删除成功');
    this.$router.replace({ name: 'pricing_rules.index' });
  }
}
</script>
